var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6 0 24 5.4 24 12C24 18.6 18.6 24 12 24C5.4 24 0 18.6 0 12C0 5.4 5.4 0 12 0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.525 4.5H8.4C6.225 4.5 4.5 6.3 4.5 8.55V15.45C4.5 17.625 6.225 19.425 8.475 19.5H15.6C17.775 19.5 19.575 17.7 19.575 15.45V8.55C19.5 6.3 17.775 4.5 15.525 4.5ZM18.15 15.375C18.15 16.875 16.95 18.15 15.375 18.15H8.55C7.05 18.15 5.775 16.875 5.85 15.375V8.625C5.85 7.125 7.05 5.85 8.55 5.85H15.375C16.875 5.85 18.15 7.125 18.15 8.625V15.375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.17521C9.90001 8.10021 8.10001 9.82521 8.10001 11.9252C8.02501 14.0252 9.75001 15.8252 11.85 15.8252C13.95 15.8252 15.75 14.1752 15.75 12.0752V12.0002C15.825 9.90021 14.1 8.17521 12 8.17521ZM12 14.4752C10.65 14.4752 9.52501 13.4252 9.45001 12.0752C9.45001 10.7252 10.5 9.60021 11.85 9.52521C13.2 9.45021 14.325 10.5752 14.4 11.9252V12.0002C14.475 13.3502 13.35 14.4752 12 14.4752Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9749 7.0498C16.4249 7.0498 16.7999 7.42481 16.7999 7.94981C16.7999 8.47481 16.4249 8.8498 15.9749 8.8498C15.5249 8.8498 15.1499 8.47481 15.1499 7.94981C15.1499 7.42481 15.5249 7.0498 15.9749 7.0498Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.99796,
    y1: 22.3947,
    x2: 18,
    y2: 1.60665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#F2203E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#B729A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5342D6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.572c1857d71a46c55899ae507540e092.svg";
export { ForwardRef as ReactComponent };